import Plyr from "plyr";

import "normalize.css";
import "./index.css";
import "plyr/dist/plyr.css";

const $fileSelectionScreen = document.querySelector("#input_container")!;
const $loadingScreen = document.querySelector("#file_loading")!;
const $playerScreen = document.querySelector("#main_player")!;

const switchScreen = (x: "fileSelection" | "loading" | "player") => {
  console.log(`[TinyVR Log] switchScreen -> ${x}`);
  switch (x) {
    case "fileSelection":
      $fileSelectionScreen.classList.remove("hide");
      $loadingScreen.classList.add("hide");
      $playerScreen.classList.add("hide");
      break;
    case "loading":
      $fileSelectionScreen.classList.add("hide");
      $loadingScreen.classList.remove("hide");
      $playerScreen.classList.add("hide");
      break;
    case "player":
      $fileSelectionScreen.classList.add("hide");
      $loadingScreen.classList.add("hide");
      $playerScreen.classList.remove("hide");
      updatePlaybackState(false, "switchScreen_player");
      break;
  }
};

switchScreen("fileSelection");

const $video = document.querySelector("#video")! as HTMLVideoElement;
const $fileSelector = document.querySelector(
  "#file_selector"
)! as HTMLInputElement;

const controller = new Plyr("#video", {
  controls: [],
  hideControls: true,
  clickToPlay: false,
  fullscreen: { enabled: false },
});

let fileUrl: string | null = null;

const handleFileChange = () => {
  switchScreen("loading");
  const file = $fileSelector.files?.[0];
  if (!file) return;

  const type = file.type;
  const canPlay = $video.canPlayType(type);

  if (!canPlay) {
    alert("Video format not supported!");
    switchScreen("fileSelection");
  }

  if (fileUrl) {
    URL.revokeObjectURL(fileUrl);
  }

  fileUrl = URL.createObjectURL(file);
  controller.source = {
    type: "video",
    sources: [
      {
        src: fileUrl,
        provider: "html5",
      },
    ],
  };
  $fileSelector.value = "";
  switchScreen("player");
};

$fileSelector.addEventListener("change", handleFileChange, false);

const $canvas = document.querySelector("#stage")! as HTMLCanvasElement;
const ctx = $canvas.getContext("2d")!;

const handleWindowResize = () => {
  $canvas.width = window.innerWidth * window.devicePixelRatio;
  $canvas.height = window.innerHeight * window.devicePixelRatio;
};

handleWindowResize();
window.addEventListener("resize", handleWindowResize);

const localScale = localStorage.getItem("scale");
const localDistance = localStorage.getItem("distance");

let paintMode: string = localStorage.getItem("paintMode") || "contain";
let scale = localScale ? Number.parseFloat(localScale) : 100;
let distance = localDistance ? Number.parseFloat(localDistance) : 0;
let videoMode = localStorage.getItem("videoMode") || "2d";
let isSBS = videoMode === "sbs";

const paintFill = () => {
  const paintOffset = window.innerWidth * (distance / 100);
  const scaleConfig = scale / 100;
  // @ts-ignore
  const $video = controller.media;

  const cw = $canvas.width;
  const ch = $canvas.height;
  const vw = $video.videoWidth;
  const vh = $video.videoHeight;

  const py = (ch / 2) * (1 - scaleConfig);
  const sourceW = isSBS ? vw / 2 : vw;
  const sourceH = vh;

  ctx.drawImage(
    $video,
    0,
    0,
    sourceW,
    sourceH,
    (cw / 2) * (1 - scaleConfig) - paintOffset,
    py,
    (cw / 2) * scaleConfig,
    ch * scaleConfig
  );
  ctx.drawImage(
    $video,
    isSBS ? vw / 2 : 0,
    0,
    sourceW,
    sourceH,
    cw / 2 + paintOffset,
    py,
    (cw / 2) * scaleConfig,
    ch * scaleConfig
  );
};

const paintContain = () => {
  const paintOffset = window.innerWidth * (distance / 100);
  const scaleConfig = scale / 100;
  // @ts-ignore
  const $video = controller.media;

  const cw = $canvas.width;
  const ch = $canvas.height;
  const vw = $video.videoWidth;
  const vh = $video.videoHeight;

  const sourceW = isSBS ? vw / 2 : vw;
  const sourceH = vh;

  let x: number, y: number, pw: number, ph: number;
  if ((sourceW / sourceH) >= (cw / 2 / ch)) {
    const scaleRatio = (cw / sourceW / 2) * scaleConfig;
    pw = sourceW * scaleRatio;
    ph = sourceH * scaleRatio;
  } else {
    const scaleRatio = (ch / sourceH) * scaleConfig;
    pw = sourceW * scaleRatio;
    ph = sourceH * scaleRatio;
  }

  x = cw / 2 - pw;
  y = ch / 2 - ph / 2;

  ctx.drawImage(
    $video,
    0,
    0,
    sourceW,
    sourceH,
    x - paintOffset,
    y,
    pw,
    ph
  );
  ctx.drawImage(
    $video,
    isSBS ? vw / 2 : 0,
    0,
    sourceW,
    sourceH,
    cw / 2 + paintOffset,
    y,
    pw,
    ph
  );
};

const paintCover = () => {
  const scaleConfig = scale / 100;
  const paintOffset = window.innerWidth * (distance / 100);

  // @ts-ignore
  const $video = controller.media;

  const cw = $canvas.width;
  const ch = $canvas.height;
  const vw = $video.videoWidth;
  const vh = $video.videoHeight;

  const paintRatio = cw / 2 / ch;
  const sourceW = isSBS ? vw / 2 : vw;
  const sourceH = vh;

  let sx_rel: number, sy_rel: number, sw: number, sh: number;
  if ((sourceW / sourceH) >= paintRatio) {
    sw = sourceH * paintRatio;
    sh = sourceH;
    sx_rel = (sourceW - sw) / 2;
    sy_rel = 0;
  } else {
    sw = sourceW;
    sh = sourceW / paintRatio;
    sx_rel = 0;
    sy_rel = (sourceH - sh) / 2;
  }

  const px = (cw / 2) * (1 - scaleConfig);
  const py = (ch / 2) * (1 - scaleConfig);

  ctx.drawImage(
    $video,
    sx_rel,
    sy_rel,
    sw,
    sh,
    px - paintOffset,
    py,
    (cw / 2) * scaleConfig,
    ch * scaleConfig
  );
  ctx.drawImage(
    $video,
    (isSBS ? vw / 2 : 0) + sx_rel,
    sy_rel,
    sw,
    sh,
    cw / 2 + paintOffset,
    py,
    (cw / 2) * scaleConfig,
    ch * scaleConfig
  );
};

const paint = () => {
  ctx.clearRect(0, 0, $canvas.width, $canvas.height);

  switch (paintMode) {
    case "contain":
      paintContain();
      break;
    case "cover":
      paintCover();
      break;
    case "fill":
      paintFill();
  }
};

const updateProgressUI = () => {
  if (isDraggingProgress) return;

  // @ts-ignore
  const $video = controller.media || document.querySelector("#video");
  const currentTime = ($video && $video.currentTime !== undefined) ? $video.currentTime : (controller.currentTime || 0);
  const duration = ($video && $video.duration !== undefined && !isNaN($video.duration)) ? $video.duration : (controller.duration || 0);

  const pct = duration > 0 ? (currentTime / duration) * 100 : 0;

  $progressSliders.forEach(s => {
    s.value = pct.toString();
    s.style.setProperty('--value', `${pct.toFixed(2)}%`);
  });

  updateTimeDisplays(currentTime, duration);
};

const handleRaf = () => {
  if (!controller.playing) return;

  paint();
  updateProgressUI();

  window.requestAnimationFrame(handleRaf);
};

const handleVideoPlay = () => handleRaf();

// Controls toggle logic
const $topBars = document.querySelectorAll(".top_bar");
const $bottomControls = document.querySelectorAll(".bottom_controls");
const $vrSplitContainer = document.querySelector("#main_player .vr-split-container");

let toggleTimeout = 0;
const handleShowControls = () => {
  $topBars.forEach(el => el.classList.remove("hidden"));
  $bottomControls.forEach(el => el.classList.remove("hidden"));

  window.clearTimeout(toggleTimeout);
  toggleTimeout = window.setTimeout(() => {
    $topBars.forEach(el => el.classList.add("hidden"));
    $bottomControls.forEach(el => el.classList.add("hidden"));
  }, 3000);
};

// Window click listener to toggle play/pause when tapping canvas
window.addEventListener("click", (e) => {
  const target = e.target as HTMLElement;
  handleShowControls();

  const isInteractive = target.closest(".top_bar") || 
                        target.closest(".bottom_controls") || 
                        target.closest("input") || 
                        target.closest("button") || 
                        target.closest("select") ||
                        target.closest(".open-btn-img");
                        
  if (!isInteractive) {
    if (controller.playing) {
      controller.pause();
    } else {
      controller.play();
    }
  }
});

window.addEventListener("pointermove", handleShowControls);

// Synchronizing settings controls across both eyes
const $scaleSliders = document.querySelectorAll(".scale-slider") as NodeListOf<HTMLInputElement>;
const $distanceSliders = document.querySelectorAll(".distance-slider") as NodeListOf<HTMLInputElement>;
const $scaleModeSelects = document.querySelectorAll(".scale-mode-select") as NodeListOf<HTMLSelectElement>;
const $videoModeSelects = document.querySelectorAll(".video-mode-select") as NodeListOf<HTMLSelectElement>;

$scaleSliders.forEach($slider => {
  $slider.value = scale.toString();
  $slider.addEventListener("input", (e) => {
    const target = e.target as HTMLInputElement;
    scale = Number.parseFloat(target.value);
    localStorage.setItem("scale", scale.toString());
    $scaleSliders.forEach(s => { if (s !== target) s.value = target.value; });
    paint();
  });
});

$distanceSliders.forEach($slider => {
  $slider.value = distance.toString();
  $slider.addEventListener("input", (e) => {
    const target = e.target as HTMLInputElement;
    distance = Number.parseFloat(target.value);
    localStorage.setItem("distance", distance.toString());
    $distanceSliders.forEach(s => { if (s !== target) s.value = target.value; });
    paint();
  });
});

$scaleModeSelects.forEach($select => {
  $select.value = paintMode;
  $select.addEventListener("change", (e) => {
    const target = e.target as HTMLSelectElement;
    paintMode = target.value;
    localStorage.setItem("paintMode", paintMode);
    $scaleModeSelects.forEach(s => { if (s !== target) s.value = target.value; });
    paint();
  });
});

$videoModeSelects.forEach($select => {
  $select.value = videoMode;
  $select.addEventListener("change", (e) => {
    const target = e.target as HTMLSelectElement;
    videoMode = target.value;
    isSBS = videoMode === "sbs";
    localStorage.setItem("videoMode", videoMode);
    $videoModeSelects.forEach(s => { if (s !== target) s.value = target.value; });
    paint();
  });
});

// Custom play/pause controls sync
const $playPauseButtons = document.querySelectorAll(".play-pause");
const $progressSliders = document.querySelectorAll(".progress-slider") as NodeListOf<HTMLInputElement>;
let isDraggingProgress = false;

const updatePlayPauseIcons = (playing: boolean) => {
  const $playIcons = document.querySelectorAll(".icon-play");
  const $pauseIcons = document.querySelectorAll(".icon-pause");
  if (playing) {
    $playIcons.forEach(i => i.classList.add("hide"));
    $pauseIcons.forEach(i => i.classList.remove("hide"));
  } else {
    $playIcons.forEach(i => i.classList.remove("hide"));
    $pauseIcons.forEach(i => i.classList.add("hide"));
  }
};

const updatePlaybackState = (playing: boolean, reason: string = "unspecified") => {
  const $vrSplit = document.querySelector("#main_player .vr-split-container");
  console.log(`[TinyVR Log] updatePlaybackState -> playing: ${playing}, reason: "${reason}", container:`, $vrSplit);
  updatePlayPauseIcons(playing);
  if ($vrSplit) {
    if (playing) {
      $vrSplit.classList.remove("paused");
    } else {
      $vrSplit.classList.add("paused");
    }
    console.log(`[TinyVR Log] Updated container className: "${$vrSplit.className}"`);
  } else {
    console.warn(`[TinyVR Warning] #main_player .vr-split-container NOT found in DOM!`);
  }
};

// Initialize with paused class
updatePlaybackState(false, "module_init");

$playPauseButtons.forEach($btn => {
  $btn.addEventListener("click", (e) => {
    e.stopPropagation();
    console.log("[TinyVR Log] Play/Pause button clicked. Current playing state:", controller.playing);
    if (controller.playing) {
      controller.pause();
    } else {
      controller.play();
    }
  });
});

// Settings button behavior to toggle panel on both sides
const $settingsButtons = document.querySelectorAll(".settings");
$settingsButtons.forEach($btn => {
  $btn.addEventListener("click", (e) => {
    e.stopPropagation();
    const isOpen = $topBars[0].classList.contains("settings-on");
    console.log("[TinyVR Log] Settings button clicked. Is panel open?", isOpen);
    $topBars.forEach(bar => {
      if (isOpen) {
        bar.classList.remove("settings-on");
      } else {
        bar.classList.add("settings-on");
      }
    });
  });
});

// Back buttons behavior
const $backButtons = document.querySelectorAll(".back");
$backButtons.forEach($btn => {
  $btn.addEventListener("click", (e) => {
    e.stopPropagation();
    console.log("[TinyVR Log] Back button clicked.");
    controller.pause();
    switchScreen("fileSelection");
  });
});

// Time and Progress Updates
const formatTime = (seconds: number) => {
  if (isNaN(seconds) || !isFinite(seconds)) return "00:00";
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

const updateTimeDisplays = (currentTime: number, duration: number) => {
  const text = `${formatTime(currentTime)} / ${formatTime(duration)}`;
  const $displays = document.querySelectorAll(".time-display");
  $displays.forEach(d => d.textContent = text);
};

// Attach listeners for timeupdate
controller.on("timeupdate", () => updateProgressUI());
controller.on("seeking", () => updateProgressUI());
controller.on("seeked", () => updateProgressUI());

const $videoEl = document.querySelector("#video") as HTMLVideoElement;
if ($videoEl) {
  $videoEl.addEventListener("timeupdate", () => updateProgressUI());
  $videoEl.addEventListener("play", () => updatePlaybackState(true, "video_el_play"));
  $videoEl.addEventListener("pause", () => updatePlaybackState(false, "video_el_pause"));
  $videoEl.addEventListener("ended", () => updatePlaybackState(false, "video_el_ended"));
}

$progressSliders.forEach($slider => {
  $slider.addEventListener("input", (e) => {
    isDraggingProgress = true;
    const target = e.target as HTMLInputElement;
    const value = Number.parseFloat(target.value);
    // @ts-ignore
    const $video = controller.media || document.querySelector("#video");
    const duration = ($video && $video.duration) ? $video.duration : (controller.duration || 0);
    const newTime = (value / 100) * duration;
    
    $progressSliders.forEach(s => {
      s.value = target.value;
      s.style.setProperty('--value', `${value.toFixed(2)}%`);
    });
    updateTimeDisplays(newTime, duration);
  });
  
  $slider.addEventListener("change", (e) => {
    const target = e.target as HTMLInputElement;
    const value = Number.parseFloat(target.value);
    // @ts-ignore
    const $video = controller.media || document.querySelector("#video");
    const duration = ($video && $video.duration) ? $video.duration : (controller.duration || 0);
    const newTime = (value / 100) * duration;
    
    console.log(`[TinyVR Log] Progress slider change -> seeking to ${newTime}s (${value}%)`);
    controller.currentTime = newTime;
    isDraggingProgress = false;
    updateProgressUI();
  });
});

controller.on("play", () => {
  console.log("[TinyVR Log] Plyr event: play");
  updatePlaybackState(true, "plyr_event_play");
  handleVideoPlay();
});

controller.on("pause", () => {
  console.log("[TinyVR Log] Plyr event: pause");
  updatePlaybackState(false, "plyr_event_pause");
});

controller.on("ready", () => {
  console.log("[TinyVR Log] Plyr event: ready");
  controller.currentTime = 0;
  const duration = controller.duration || 0;
  $progressSliders.forEach(s => {
    s.value = "0";
    s.style.setProperty('--value', "0%");
  });
  updateTimeDisplays(0, duration);
  updatePlaybackState(false, "plyr_event_ready");
  setTimeout(() => {
    paint();
  }, 500);
});

// Synchronize hover highlights between left and right twin VR UI elements
const setupHoverSync = () => {
  const leftItems = document.querySelectorAll(".vr-side.left button, .vr-side.left input, .vr-side.left select, .vr-side.left .pause-overlay");
  const rightItems = document.querySelectorAll(".vr-side.right button, .vr-side.right input, .vr-side.right select, .vr-side.right .pause-overlay");

  leftItems.forEach((leftEl, index) => {
    const rightEl = rightItems[index];
    if (!rightEl) return;

    leftEl.addEventListener("mouseenter", () => rightEl.classList.add("hover-sync"));
    leftEl.addEventListener("mouseleave", () => rightEl.classList.remove("hover-sync"));
    rightEl.addEventListener("mouseenter", () => leftEl.classList.add("hover-sync"));
    rightEl.addEventListener("mouseleave", () => leftEl.classList.remove("hover-sync"));
  });
};

setupHoverSync();

// Service Worker Logic
window.addEventListener("load", (e) => {
  registerSW();
});

async function registerSW() {
  if ("serviceWorker" in navigator) {
    try {
      await navigator.serviceWorker.register(new URL('/sw.js', import.meta.url));
    } catch (e) {
      console.error("Service Worker Registered Failed!\r\n\r\n", e);
    }
  }
}

export default {}